import axios from "axios";
import {authHeader} from "_helpers";
import {SERVER_URL} from "../config";

function listExperts(params) {
    const endpoint = `${SERVER_URL}/api/v1/experts`;
    return axios.get(endpoint,{
        params: params,
        headers: authHeader()
    })
}

function clearBalance(payload) {
    const endpoint = `${SERVER_URL}/api/v1/experts/clear-balance`;
    return axios.post(endpoint, payload,{
        headers: authHeader()
    })
}

export const expertPaymentService = {
    listExperts,
    clearBalance,
};